import React, { useState } from 'react'

import 'react-circular-progressbar/dist/styles.css'
import { useQuery } from 'react-query'
import { toast } from 'react-toastify'
import { CircularProgressbar } from 'react-circular-progressbar'

import UIButton from '../../../components/UI/UIButton'
import UICheckbox from '../../../components/UI/UICheckBox'
import UiPdfViewer from '../../../components/UiPdfViewer'
import UISubHeaderComponent from '../../../components/UI/UISubHeaderComponent'
import PoliciesLargeButton from '../../candidates/components/PoliciesLargeButton'
import UIStaightlineProressBar from '../../../components/UI/UIStaightlineProressBar'
import { Icon } from '../../../components/Icon'
import { formatDate } from '../../../utils/utils'
import { getPolicyType, policiesAgreement } from '../../../utils/types'
import { createPolicyAgreement } from '../../../api/candidate/policies'
import { getPolicyAgreement, getPolicyData, getPolicyDataById } from './apiCall'
import { Accordion, AccordionItem } from '../../candidates/components/Accordion'
import { downloadPDF } from '../../policy/utils'

const Policies = () => {
  const [isView, setIsView] = useState(false)
  const [isChecked, setIsChecked] = useState(false)
  const [id, setId] = useState('')
  const policies = useQuery('policy', () => getPolicyData())
  const policyById = useQuery(['policyById', id], () => getPolicyDataById(id))

  const policiesAgreement = useQuery('Agreements', () => getPolicyAgreement())

  function containsPolicyId(data: policiesAgreement[], id: string): boolean {
    // Check if the input data is an array
    if (!Array.isArray(data)) {
      throw new Error('Input data must be an array')
    }

    // Check if the id exists in the array of policyIds
    return data?.some((item) => item?.policyId === id)
  }

  // const policyIds =containsPolicyId(policiesAgreement.data||[],"56ab2cac-2f7d-4c4f-b017-8166fabbe23c");

  // console.log(policyIds)

  const addPolicyAgreement = async (): Promise<void> => {
    const response = (await createPolicyAgreement(id)) as {
      status?: string
      data: policiesAgreement
    }
    if (response?.status == 'successful') {
      policies.refetch()
      policiesAgreement.refetch()
      console.log(response?.data)
      // setIsOpen(!isOpen)

      toast.success('Policy Agreed.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const policyAgreementIds = policiesAgreement?.data?.map((item) => {
    return item?.policyId
  })

  function calculateCommonIdsPercentage(
    arrayOfObjects: getPolicyType[],
    policyAgreementIds: string[]
  ): { percentage: number; color: string } {
    // Step 1: Extract ids from array of objects
    let percentage: number
    let color: string
    if (policyAgreementIds?.length == 0) {
      percentage = 0
      color = 'red'
    } else {
      const objectIds = arrayOfObjects?.map((obj) => obj.id)

      // Step 2: Check for common ids
      const commonIds = objectIds?.filter((policyId) =>
        policyAgreementIds?.includes(policyId)
      )

      console.log(
        'object policies Ids common',
        Math.round(commonIds?.length / arrayOfObjects?.length)
      )

      // Step 3: Calculate percentage
      percentage = (commonIds?.length / arrayOfObjects?.length) * 100

      if (percentage >= 95) {
        color = '#01B38B'
      } else if (percentage >= 40) {
        color = '#FFA800'
      } else {
        color = '#FF6666'
      }
    }

    return { percentage, color }
  }

  return (
    <div className={'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl'}>
      {isView == false && (
        <div className="flex my-8 gap-2">
          {/* First column */}
          <div
            style={{
              height: 'calc(100vh - 100px)',
              overflow: 'auto',
              scrollbarWidth: 'none',
            }}
            className="flex flex-col w-8/12 gap-4"
          >
            {/* <div className="flex items-center gap-3">
              <p className="text-sm text-text2 font-semibold leading-6">
                Sort by
              </p>
              <div className="rounded-[40px] bg-gray2 py-2 px-4 flex justify-center items-center gap-1 cursor-pointer">
                <p className={'text-text3 font-medium text-xs leading-5'}>
                  Last Added
                </p>
                <Icon
                  name="IconChevronDown"
                  width={16}
                  height={16}
                  strokeWidth={1}
                  stroke={'#67A5B9'}
                />
              </div>
            </div> */}

            {policies?.data?.data?.map((item, index) => (
              <PoliciesLargeButton
                key={index}
                onClick={() => {
                  console.log(item)

                  setId(item.id)
                  setIsView(true)
                  console.log(item.id)
                }}
                title={item.title}
                icon="IconFileCheckInActive"
                iconStrokeWidth={1.5}
                iconSize={24}
                rightIcon={'IconDownloadCloud'}
                badgeColor={
                  containsPolicyId(policiesAgreement?.data || [], item.id) ==
                    true
                    ? 'bg-[#CCF0E8]'
                    : 'bg-[#FFD8D8]'
                }
                bagdeLabel={
                  containsPolicyId(policiesAgreement?.data || [], item.id) ==
                    true
                    ? 'Agreed'
                    : 'Not Agreed'
                }
              />
            ))}
          </div>

          {/* Second column */}
          <div className="w-4/12">
            <Accordion defaultActiveIndex={0}>
              <AccordionItem
                onClick={() => console.log('Accordion')}
                title={'Scorecard'}
                isActive={true}
                AccordionItemStyle={{
                  backgroundColor: 'rgba(230, 240, 243, 1)',
                }}
                AccordiontitleStyle={
                  'text-sm text-bluishGreen flex-1 font-semibold'
                }
                AccordionItemStyleContainer={{
                  backgroundColor: 'rgba(242, 247, 249, 1)',
                }}
                icon={'IconBarChartSquare'}
              >
                <div className="bg-gray1 flex items-center flex-col justify-center gap-4 my-8">
                  <div className="w-[160px] h-[160px]">
                    <CircularProgressbar
                      strokeWidth={5}
                      value={Number(
                        calculateCommonIdsPercentage(
                          policies?.data?.data && policies
                            ? policies?.data?.data
                            : [],
                          policyAgreementIds || []
                        ).percentage?.toFixed(0)
                      )}
                      text={`${Number(calculateCommonIdsPercentage(policies?.data?.data && policies ? policies?.data?.data : [], policyAgreementIds || []).percentage.toFixed(0))}%`}
                      styles={{
                        root: {},
                        path: {
                          stroke: calculateCommonIdsPercentage(
                            policies?.data?.data && policies
                              ? policies?.data?.data
                              : [],
                            policyAgreementIds || []
                          ).color,
                          transition: 'stroke-dashoffset 0.5s ease 0s',
                        },
                        text: {
                          fill: '#013546',
                          fontSize: '24px',
                          fontWeight: 700,
                          lineHeight: 40,
                        },
                      }}
                    />
                  </div>
                  <div className="items-center justify-center flex">
                    <p className="text-sm font-semibold  w-[80%]  text-text2 leading-6 text-center">
                      Great start! But there is still room for improvement
                    </p>
                  </div>
                  <Accordion defaultActiveIndex={0}>
                    <AccordionItem
                      onClick={() => console.log('Accordion')}
                      title={'Your score is broken down as follows:'}
                      isActive={false}
                      AccordionItemStyle={{ backgroundColor: '#FFFFFF' }}
                      AccordiontitleStyle={
                        'text-xs font-semibold text-text4 leading-5 flex-1'
                      }
                      AccordionItemStyleContainer={{
                        backgroundColor: '#FFFFFF',
                      }}
                    >
                      <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                        {policies?.data?.data?.map((item, index) => (
                          <div key={index} className="mt-3">
                            <UIStaightlineProressBar
                              percentage={
                                containsPolicyId(
                                  policiesAgreement?.data || [],
                                  item.id
                                ) == true
                                  ? 100
                                  : 0
                              }
                              label={item.title}
                              stroke={
                                containsPolicyId(
                                  policiesAgreement?.data || [],
                                  item.id
                                ) == true
                                  ? '#01B38B'
                                  : ''
                              }
                              strokeWidth={1.5}
                            />
                          </div>
                        ))}
                      </div>
                    </AccordionItem>
                  </Accordion>
                </div>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      )}
      {isView == true && (
        <div
          style={{
            height: 'calc(100vh - 100px)',
            overflow: 'auto',
            scrollbarWidth: 'none',
          }}
          className="my-4"
        >
          <UISubHeaderComponent
            mainPage="Policies"
            subPage={policyById?.data?.title}
            copy="Please ensure that you read the following policy, and please tick that you have read and understood the policy:"
            onDelete={() => { }}
            isViewMode={false}
            isCreatePolicy={false}
            onBack={() => {
              setIsView(false)
            }}
          />
          <div className="flex flex-col my-8 gap-4">
            {/* <div className="py-3 px-4 flex gap-2 items-center  bg-lightGreen  rounded-xl mt-4">
              <Icon
                name="IconCheckCircle"
                width={16}
                height={16}
                strokeWidth={1}
                stroke={'#02698C'}
              />
              <p className="text-sm font-semibold text-text2 flex-1">
                Safer Recruitment Policy Updated
              </p>
              <Icon
                name="IconXClose"
                width={16}
                height={16}
                strokeWidth={1}
                stroke={'#02698C'}
              />
            </div> */}
            <div className="bg-gray1 rounded-xl">
              <div className="py-3 px-4 flex gap-2 items-center bg-gray2 rounded-xl rounded-b-none">
                <Icon
                  name="IconFileCheck"
                  width={16}
                  height={16}
                  strokeWidth={1}
                  stroke={'#02698C'}
                />
                <p className="text-sm font-semibold text-text2 flex-1">
                  Policy Document
                </p>
                <div
                  onClick={() => {
                    if (!policyById?.data?.policyDocumentUrl) return

                    if ((policyById?.data?.policyDocumentUrl as unknown as string) == 'IN PROGRESS') {
                      return toast.warning("Scanning the file, please check again in a few seconds.", {
                        position: 'top-right',
                      })
                    }
                    if ((policyById?.data?.policyDocumentUrl as unknown as string) == 'NoSuchKey') {
                      return toast.warning("File is removed", {
                        position: 'top-right',
                      })
                    }
                    downloadPDF(
                      policyById?.data?.policyDocumentUrl,
                      'data.pdf'
                    )
                  }}
                >
                  <Icon
                    name="IconDownloadCloud"
                    width={16}
                    height={16}
                    strokeWidth={1}
                    stroke={'#02698C'}
                  />
                </div>
              </div>
              <div className="p-4 px-40">
                <UiPdfViewer url={policyById?.data?.policyDocumentUrl || ''} />
                {/* <img src={policyById.data?.policyDocument} width={'100%'} height={'100%'} /> */}
              </div>
            </div>

            <div>
              <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
                <table className="rounded-[16px] overflow-hidden border w-full border-white">
                  <tbody>
                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Related Policy Document
                      </td>
                      <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                        {
                          policyById?.data?.otherInformation
                            ?.relatedPolicyDocuments
                        }
                      </td>
                    </tr>
                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Owner
                      </td>
                      <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                        {policyById?.data?.otherInformation.owner}
                      </td>
                    </tr>
                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Version
                      </td>
                      <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                        {policyById?.data?.otherInformation.version}
                      </td>
                    </tr>

                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Approval Date
                      </td>
                      <td className="px-4  h-[48px] py-2 border border-white">
                        <div className="flex gap-3 items-center">
                          <p className="text-[14px] font-semibold leading-6 text-text1">
                            {formatDate(
                              policyById?.data?.otherInformation
                                ?.approvedDate || ''
                            )}
                          </p>
                          {/* <Icon
                            name={'IconAlertTriangle'}
                            stroke={'#02698C'}
                            strokeWidth={1}
                            width={16}
                            height={16}
                          /> */}
                        </div>
                      </td>
                    </tr>
                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Approved By
                      </td>
                      <td className="px-4 w-[30%] h-[48px] py-2 border border-white">
                        <div className="flex w-[30%] gap-2 items-center bg-gray2 p-3 rounded-xl">
                          <Icon
                            name={'IconUserCircle'}
                            stroke={'#02698C'}
                            strokeWidth={1.2}
                            width={16}
                            height={16}
                          />
                          <p className="text-sm font-semibold leading-6 text-text5">
                            {policyById?.data?.otherInformation?.approvedBy}
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Commence Date
                      </td>
                      <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                        {formatDate(
                          policyById?.data?.otherInformation?.commenceDate?.substring(
                            0,
                            16
                          ) || ''
                        )}
                      </td>
                    </tr>
                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Last Review Date
                      </td>
                      <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                        {formatDate(
                          policyById?.data?.otherInformation?.lastReviewDate?.substring(
                            0,
                            16
                          ) || ''
                        )}
                      </td>
                    </tr>
                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Next Review Date
                      </td>
                      <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                        {formatDate(
                          policyById?.data?.otherInformation?.nextReviewDate?.substring(
                            0,
                            16
                          ) || ''
                        )}
                      </td>
                    </tr>

                    {/* Add more rows as needed */}
                  </tbody>
                </table>
              </div>
            </div>
            {containsPolicyId(policiesAgreement?.data || [], id) == false && (
              <div className="p-4 flex flex-1 flex-col border border-gray3 gap-4 rounded-2xl">
                <p className="text-sm font-semibold leading-6 text-text2">
                  I confirm that I have read and understood the policy document
                </p>
                <UICheckbox
                  label={'I agree'}
                  checked={isChecked}
                  onChange={() => setIsChecked(!isChecked)}
                />
              </div>
            )}
          </div>

          {containsPolicyId(policiesAgreement?.data || [], id) == false && (
            <>
              <div className="bg-gray3 w-full h-[1px] my-3"></div>
              <div className="w-[33%] mt-6">
                <UIButton
                  onClick={addPolicyAgreement}
                  disabled={!isChecked}
                  label="Submit"
                />
              </div>
            </>
          )}
        </div>
      )}
    </div>
  )
}

export default Policies
